import React, { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORE = "ft_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(STORE) || "[]");
      return Array.isArray(saved) ? saved : [];
    } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(STORE, JSON.stringify(items)); } catch { /* ignore */ }
  }, [items]);

  const add = (item) => {
    const cartItem = { id: `ci_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`, ...item };
    setItems((prev) => [...prev, cartItem]);
    toast.success(`Added to trip cart — ${item.title}`);
  };
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const subtotal = items.reduce((a, i) => a + (Number(i.price) || 0), 0);
  const kinds = new Set(items.map((i) => i.kind));
  const combo = kinds.has("flight") && kinds.has("hotel");
  const discount = combo ? Math.round(subtotal * 0.1) : 0;
  const total = subtotal - discount;

  return (
    <CartContext.Provider value={{ items, add, remove, clear, subtotal, discount, total, combo, count: items.length }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
